import functions from "./functions.js";
import { Select2 } from "./components/select2";

$(() => {
    booking.init();
});

const booking = {
    $form: null,
    form: null,
    calc: [],
    totalAmount: null,
    params: {},
    insurance: null,

    init() {

        this.$form = $('.booking-form');
        this.form = this.$form[0];

        if (! this.$form.length) {
            return;
        }

        this.checkPaymentType();
        this.prepareForBooking();
        this.getGuestsData();

        booking.objectId = booking.$form.attr('data-objectid');

        if ( ! booking.calc.length) {
            return;
        }

        this.totlaGuests = 0;
        booking.calc.forEach(calcItem => {
            if (calcItem.itemDefinitionId.categoryId.key == 'baseRate'
                && [1,6].includes(calcItem.itemDefinitionId.objectGroupId.id)
            ) {
                let guests = calcItem.guests.split(',');
                this.totlaGuests = +guests[0] + +guests[1];
            }
        });

        this.$form.on('change', 'input[type="checkbox"], input[type="radio"]', function (e) {
            let $calcItem = $(e.currentTarget).closest('.calc-item');
            let $quantity = $calcItem.find('[name=quantity]');
            let value = $quantity.length ? +$quantity.val() : this.totlaGuests;
            let checked = $(e.currentTarget).is(':checked') ? 1 : 0;

            if ($quantity.length) {
                if (checked && !value) {
                    $quantity.prop('value', booking.totlaGuests);
                } else if (! checked && value) {
                    $quantity.prop('value', 0);
                }
                $quantity.trigger('change');
            }

            booking.calculate($(e.currentTarget));
        });

        $('[name=quantity]').on('change', e => {
            const $target = $(e.currentTarget);
            let value = +$target.val();
            let $calcItem = $target.closest('.calc-item');
            let $checkbox = $calcItem.find('input[type="checkbox"]');

            if (value && ! $checkbox.is(':checked')) {
                $checkbox.prop('checked', true);
            } else if (! value && $checkbox.is(':checked')) {
                $checkbox.prop('checked', false);
            }

            booking.calculate($(e.currentTarget));
        });

        $('[name^="skiPackage"]').on('change', e => {
            const $target = $(e.currentTarget);
            const guestindex = $target.data('guestindex');
            let value = $target.val();

            const $skiPass = $('[name^="skiPass-' + guestindex + '"]');
            let data = $skiPass.data('data');

            $skiPass.prop('disabled', ! value);
            $skiPass.prop('required', value);

            let filteredData = data.filter(item => {
                return item.skiPackage == value;
            });

            filteredData.sort(function (a, b) {
                return a.minStay - b.minStay;
            });

            $skiPass.empty();
            $skiPass.append('<option></option>');

            filteredData.forEach(item => {

                item.title = item.title ? item.title.replace(value + ' - ', '') : null;

                // data-calcDiscount="${ item.calcDiscount }"
                const newOption = new Option(
                    `<div class="pricelist-item">
                        <div class="d-flex justify-content-between">
                            <span class="title">${ item.title ? item.title : item.text }</span>
                            ${ item.price ? '<span class="price text-warning ms-2">' + item.price + '</span>' : '' }
                        </div>
                    </div>`,
                    item.id, 
                    false, 
                    false);
                    //${ item.description ? '<div class="description">' + item.description + '</div>' : '' }

                $skiPass.append(newOption);
            });
        });

        $('[name^="skiPass-"]').on('change', e => {
            const $target = $(e.currentTarget);
            const guestindex = $target.data('guestindex');
            let value = $target.val();
            value = value ? JSON.parse(value) : value;

            const $skiPassDateFrom = $('[name^="skiPassDateFrom-' + guestindex + '"]');
            let data = $target.data('data');

            let skiPassItem = data.find(item => {
                return item.itemUniqueId == value.id;
            });

            let validStays = [];

            if (skiPassItem) {
                let skiPassItemCalc = JSON.parse(skiPassItem.id);
                //let calcDiscount = skiPassItem.calcDiscount ? JSON.parse(skiPassItem.calcDiscount) : null;
                let dateFrom = new Date(skiPassItemCalc.dateFrom);
                let dateTo = new Date(skiPassItemCalc.dateTo);

                const diffDays = Math.round((dateTo - dateFrom) / (1000 * 60 * 60 * 24));

                for (let i = 0; i < diffDays; i++) {
                    const currentDate = new Date(skiPassItemCalc.dateFrom);
                    currentDate.setDate(currentDate.getDate() + i);

                    const minimumEndDate = new Date(currentDate);
                    minimumEndDate.setDate(minimumEndDate.getDate() + skiPassItem.minStay);

                    if (minimumEndDate <= dateTo) {

                        let currentDateDay = currentDate.getDate();
                        currentDateDay = currentDateDay < 10 ? '0' + currentDateDay : currentDateDay;

                        let minimumEndDay = minimumEndDate.getDate();
                        minimumEndDay = minimumEndDay < 10 ? '0' + minimumEndDay : minimumEndDay;

                        let skiPassItemCalc = JSON.parse(skiPassItem.id);

                        skiPassItem.dateFrom = skiPassItemCalc.dateFrom = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDateDay;
                        skiPassItem.dateTo = skiPassItemCalc.dateTo = minimumEndDate.getFullYear() + '-' + (minimumEndDate.getMonth() + 1) + '-' + minimumEndDay;

                        skiPassItem.id = JSON.stringify(skiPassItemCalc);

                        validStays.push({
                            dateFrom: currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDateDay,
                            dateTo: minimumEndDate.getFullYear() + '-' + (minimumEndDate.getMonth() + 1) + '-' + minimumEndDay,
                            calc: JSON.stringify(skiPassItemCalc)
                        });
                    }
                }
            }

            $skiPassDateFrom.empty();
            //$skiPassDateFrom.append('<option></option>');

            validStays.forEach(item => {

                const newOption = new Option(
                    `<div class="pricelist-item fw-bold">
                        ${ functions.formatDate(item.dateFrom) } - ${ functions.formatDate(item.dateTo) }
                    </div>`,
                    item.calc, 
                    false, 
                    false);

                $skiPassDateFrom.append(newOption);
            });

            $skiPassDateFrom.prop('disabled', ! value);
            $skiPassDateFrom.prop('required', value);

            // ne možeš izabrati ako nisi unio podatke?

            booking.selectionCalculate($target);
        });

        $('[name^="skiPassDateFrom-"]').on('change', e => {
            const $target = $(e.currentTarget);
            let value = $target.val();
            value = value ? JSON.parse(value) : value;
            const guestindex = $target.data('guestindex');

            const $skiPass = $('[name^="skiPass-' + guestindex + '"]');
            let data = $skiPass.data('data');

            let skiPassItem = data.find(item => {
                return item.itemUniqueId == value.id;
            });

            let skiPassItemIndex = data.indexOf(skiPassItem);
            let skiPassItemCalc = JSON.parse(data[skiPassItemIndex].id);

            data[skiPassItemIndex].dateFrom = skiPassItemCalc.dateFrom = value.dateFrom;
            data[skiPassItemIndex].dateTo = skiPassItemCalc.dateTo = value.dateTo;
            data[skiPassItemIndex].id = JSON.stringify(skiPassItemCalc);

            $target.attr('data-data', JSON.stringify(data));

            setTimeout(() => booking.selectionCalculate($target));
        });

        booking.$payment = $('.payment-details');

        // insurance
        const $insurance = $('[name="insurance"]');
        if($insurance.length) {
            $insurance.on('change', e => {
                const target = e.currentTarget;
                this.insurance = target.checked ? target.value : null;
            });
        }

        this.$form.on('submit', e => {
            //e.preventDefault();
            //e.stopPropagation();

            if(this.insurance) {
                const $note = booking.$form.find('[name="note"]');
                let noteValue = $note.val();
                noteValue = this.insurance + ' ' + noteValue;
                $note.val(noteValue);
            }

            this.submit();
        });

        this.$form.on('change', e => {
            const $target = $(e.currentTarget);
            const data = functions.getFormData($target);

            let guestsData = {};

            const guestsDataKeys = [
                'guestFirstName',
                'guestLastName',
                'birthDateDay',
                'birthDateMonth',
                'birthDateYear',
                'gender',
            ];
            /*const holderDataKeys = [
                'firstName',
                'lastName',
                'email',
                'phone',
                'address',
            ];*/

            for (const [key, value] of Object.entries(data)) {
                // ako key starts with guestsDataKey, spremi u JSON za cookie guestsData
                let hasKey = guestsDataKeys.find(guestDataKey => {
                    return key.startsWith(guestDataKey);
                });
                if(hasKey) {
                    let calcIds = value.split(',');

                    calcIds.forEach((itemValue, calcId) => {
                        if(! guestsData[calcId]) guestsData[calcId] = {};
                        guestsData[calcId][key] = itemValue;
                    });
                    //guestsData[key] = value;
                }

                // ako je key == holderDataKey, spremi u JSON cookie holderData

            }
            
            //functions.setCookie('guestsData', null, -1);
            // cookie neka se cleara za tjedan dana
            //functions.setCookie('guestsData', JSON.stringify(guestsData), 7);
        });

        const $partnerCodeSuccess = $(".partnerCodeSuccess");
        const $partnerCodeError = $(".partnerCodeError");

        if($('#partnerCodeApply').length) {
            $('#partnerCodeApply').on('click', function (e) {
                e.preventDefault();

                let params = functions.getUrlData(false);
                params.partnerCode = $("[name='partnerCode']").val();
                params.language = functions.getLang();

                $partnerCodeSuccess.addClass('d-none');
                $partnerCodeError.addClass('d-none');

                //$('button[type="submit"]').attr('disabled', 'disabled');

                if (! /^sa\d+$/.test(params.partnerCode.toLowerCase())) {
                    $.get('/services/promoCode/', $.param({ promoCode : params.partnerCode, language : params.language, objectId : booking.objectId })).then(response => {
                        response = JSON.parse(response);
                        //booking.$pricingContainer.find(".promoDiscountItem").remove();

                        if (response.status && (+response.amount || +response.percent)) {
                            //booking.$partnerCodeSuccess.removeClass('d-none');
                            //booking.$partnerCodeError.addClass('d-none');

                            //booking.applyDiscount(response.amount,  response.percent, response.perPerson, 'Promo kod ' + params.partnerCode.toUpperCase(), response.promoCodeId, response.quantity);
                        } else {
                            //booking.$partnerCodeSuccess.addClass('d-none');
                            //booking.$partnerCodeError.removeClass('d-none');
                        }
                    });

                    return;
                }

                params.partnerCode && $.get('/services/booking_form_cart/', $.param(params)).then(response => {
                    response = JSON.parse(response);
                    if (response.status) {
                        $('.cart-booking').replaceWith(response.html);
                        booking.prepareForBooking();
                        $partnerCodeSuccess.removeClass('d-none');
                        $partnerCodeError.addClass('d-none');
                    } else {
                        $partnerCodeSuccess.addClass('d-none');
                        $partnerCodeError.removeClass('d-none');
                    }

                    // LOZAD
                    window.observer.observe();

                    $(".select2:not([data-select2-id])").each((i, elem) => {
                        elem._select2 = new Select2(elem);
                    });

                    booking.getGuestsData();
                });
            });
        }

        // recalculate if guests birthDates are different than in initial calc

        let cart_data = functions.getUrlData(false);
        cart_data = JSON.parse(cart_data.cart_data);

        $('.booking-form').on('blur', '.guests input[name]', function (e) {

            const $guestsRow = $(e.currentTarget).closest('.guests');
            const calcId = $guestsRow.attr('data-guests-parentid');
            let calc = booking.calc.find((calc, i) => calc.calcId == calcId);
            if ( !calc ) {
                calc = cart_data[calcId-1];
            }

            const dateFrom = calc.dateFrom;
            const guests = (calc.guests || '').split(',');
            const adults = +guests[0];
            const children = +guests[1] || 0;
            const childrenAges = guests.slice(2, 2+ children).sort((a,b) => a < b ? 1 : -1);


            let _adults = 0;
            let _childrenAges = [];
            let guestInfo = [];
            $guestsRow.find('[data-guests]').map((i, elem) => {
                let $year = $guestsRow.find('input[name="birthDateYear' + i + '"]');
                let $month = $guestsRow.find('input[name="birthDateMonth' + i + '"]');
                let $day = $guestsRow.find('input[name="birthDateDay' + i + '"]');

                let year = (+$year.val() || '') + '';
                let month = (+$month.val() || '') + '';
                let day = (+$day.val() || '') + '';

                if ( year && month && day ) {

                    if ( year.length !== 4 || year < 1925) {
                        $year.addClass('is-invalid');
                    } else {
                        $year.removeClass('is-invalid');
                    }

                    if ( month > 12 || month < 1) {
                        $month.addClass('is-invalid');
                    } else {
                        $month.removeClass('is-invalid');
                    }

                    if ( day > 31 || day < 1) {
                        $day.addClass('is-invalid');
                    } else {
                        $day.removeClass('is-invalid');
                    }

                    let age = new Date(new Date(dateFrom) - new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)).getFullYear() - 1970;

                    if ( age >= 18 ) {
                        _adults++;
                    } else {
                        _childrenAges.push(String(age));
                    }
                }

                guestInfo[i] = {
                    gender: $guestsRow.find("[name='gender" + i + "']").val(),
                    firstName: $guestsRow.find("input[name='guestFirstName" + i + "']").val(),
                    lastName: $guestsRow.find("input[name='guestLastName" + i + "']").val(),
                    day: day,
                    month: month,
                    year: year
                };
            });

            if ($('.guests').find('.is-invalid').length) {
                $('button[type="submit"]').attr('disabled', 'disabled');
                return;
            } else {
                $('button[type="submit"]').removeAttr('disabled');
            }

            _childrenAges.sort((a,b) => a < b ? 1 : -1);
            // continue only if all guests are populated
            if ( (adults + childrenAges.length) == (_adults + _childrenAges.length)) {
                // AND different from initial guests
                if ( adults != _adults || childrenAges.join(',') != _childrenAges.join(',') ) {
                    let newGuests = `${_adults},${_childrenAges.length}${_childrenAges.length ? ',' + _childrenAges.join(',') : ''}`;
                    let params = booking.recalculateParams || functions.getUrlData(false);
                    params.cart_data = JSON.parse(params.cart_data);
                    params.cart_data[calcId-1].guests = newGuests;
                    if (params.cart_data[calcId-1].optionRefId) {
                        params.cart_data[calcId-1].optionRefId = null;
                    }
                    params.cart_data = JSON.stringify(params.cart_data);
                    params.language = functions.getLang();
                    params.partnerCode = $("[name='partnerCode']").val();
                    // request in flight or confirm() shown - skip (confirm steals focus and fires blur)
                    if (booking.confirmBusy) {
                        return;
                    }
                    booking.recalculateParams = params;
                    $('button[type="submit"]').attr('disabled', 'disabled');
                    ! booking.confirmBusy && $.get('/services/booking_form_cart/', $.param(booking.recalculateParams)).then(response => {
                        booking.confirmBusy = true;
                        response = JSON.parse(response);
                        if (response.status) {
                            $('.cart-booking').replaceWith(response.html);
                            booking.prepareForBooking();
                            window.observer.observe();
                            cart_data[calcId-1].guests = newGuests;
                            confirm('Zbog promena u godinama gostiju došlo je do novog obračuna.\nProverite pre nego nastavite.');

                            if (booking.calc.length) {
                                $('button[type="submit"]').removeAttr('disabled');
                            }

                            let $guestsRow = $('[data-guests-parentid="'+calcId+'"]');
                            $guestsRow.find('[data-guests]').map((i, elem) => {
                                $guestsRow.find("[name='gender" + i + "']").val(guestInfo[i].gender);
                                $guestsRow.find("input[name='guestFirstName" + i + "']").val(guestInfo[i].firstName);
                                $guestsRow.find("input[name='guestLastName" + i + "']").val(guestInfo[i].lastName);
                                $guestsRow.find("input[name='birthDateYear" + i + "']").val(guestInfo[i].year);
                                $guestsRow.find("input[name='birthDateMonth" + i + "']").val(guestInfo[i].month);
                                $guestsRow.find("input[name='birthDateDay" + i + "']").val(guestInfo[i].day);
                            });
                        }
                    }).always(() => {
                        // blur caused by confirm() is dispatched after it closes
                        setTimeout(() => booking.confirmBusy = false, 300);
                    });
                }
            }
        });

        let transferSupItems = booking.calc.filter((calcItem, index) => {
            return calcItem.itemDefinitionId.id == 160 && ! calcItem.guestIndex;
        });
        transferSupItems.forEach(transferSupItem => {
            let aGuests = transferSupItem.guests.split(',');
            let countGuests = +aGuests[0] + +aGuests[1];

            transferSupItem.guestIndex = "0";
            transferSupItem.guests = '1,0,0';
            transferSupItem.quantity = 1;
            transferSupItem.total = transferSupItem.price;
            transferSupItem.totalIn = transferSupItem.priceIn;

            for(let i = 1; i < countGuests; i++) {
                let newItem = {
                    guestIndex: '' + i,
                    calcId: transferSupItem.calcId,
                    data: transferSupItem.data, //JSON.stringify(transferSupItem.data),
                    dateFrom: transferSupItem.dateFrom,
                    dateTo: transferSupItem.dateTo,
                    guests: transferSupItem.guests,
                    id: transferSupItem.id,
                    inCalc: transferSupItem.inCalc,
                    isOptional: transferSupItem.isOptional,
                    itemDefinitionId: transferSupItem.itemDefinitionId,
                    onSpot: transferSupItem.onSpot,
                    paymentTypeId: transferSupItem.paymentTypeId,
                    price: transferSupItem.price,
                    priceConverted: transferSupItem.priceConverted,
                    priceIn: transferSupItem.priceIn,
                    pricelistId: transferSupItem.pricelistId,
                    quantity: transferSupItem.quantity,
                    total: transferSupItem.total,
                    unitId: transferSupItem.unitId,
                    skipCalculate: true,
                }
                
                booking.calc.push(newItem);
            }
        });

        $('[name^="placeFromId"]').on('change', e => {
            const $target = $(e.currentTarget);
            booking.selectionCalculate($target);
        });

        booking.calc.forEach(calcItem => {
            if (calcItem.itemDefinitionId.id == 160) {

                const $placeFromId = $('[name^="placeFromId"][data-calcId="' + calcItem.calcId + '"][data-guestIndex="' + calcItem.guestIndex + '"]');

                //let value = JSON.stringify(calcItem);
                let value = calcItem.data.placeFromId.id;
                $placeFromId.val(value).trigger('change');
            }
        });

        $('[name="guestFirstName0"]').on('change', e => {
            const $target = $(e.currentTarget);
            let value = $target.val();

            $('[name="firstName"]').val(value);
        });
        $('[name="guestLastName0"]').on('change', e => {
            const $target = $(e.currentTarget);
            let value = $target.val();

            $('[name="lastName"]').val(value);
        });
        
    },
    selectionCalculate($target) {
        const value = $target.val();
        let dataItem = null;
        let calc = null;
        const data = $target.attr('data-data') ? JSON.parse($target.attr('data-data')) : [];
        const guestIndex = $target.attr('data-guestIndex');
        const calcId = $target.attr('data-calcId');

        if(data) {
            dataItem = data.filter(item => {
                return item.id == value;
            })[0];
            calc = dataItem ? (dataItem.calc ? dataItem.calc : dataItem.id) : null;
            //calc = dataItem ? dataItem.id : null;
        }

        $target.attr('data-calc', calc);

        if(calc) {
            let item = JSON.parse(calc);
            if (item.data) {
                item.data = JSON.parse(item.data);
            }

            if (item.itemDefinitionId.id == 35) {
                booking.calc.forEach((calcItem, index) => {
                    if(guestIndex == calcItem.guestIndex && calcId == calcItem.calcId) {
                        delete booking.calc[index];
                    }
                });
                booking.calc = booking.calc.filter(item => item);

            } else {
                item.inCalc = item.isOptional ? 0 : 1;
    
                $target.attr('data-id', item.id);
    
                item.guestIndex = guestIndex;
                item.inCalc = 1;
    
                let itemExists = false;
                booking.calc.forEach((calcItem, index) => {
                    if(guestIndex == calcItem.guestIndex && calcId == calcItem.calcId) {
                        booking.calc[index] = item;
                        itemExists = true;
                    }
                });
                ! itemExists && booking.calc.push(item);
            }

        } else {
            // dodati sopstveni item fake skipCalculation - price transfera
            // maknut ću ga kod submit

            let transferItem = booking.calc.find(calcItem => {
                return calcId == calcItem.calcId && calcItem.itemDefinitionId.id == 35;
            });

            // ovo se može mergeati kod submita
            // i još treba na transferu staviti quantity -1 i guests -1, smanjiti total - price i totalIn - price
            let itemExists = false;
            transferItem && booking.calc.forEach((calcItem, index) => {

                if (guestIndex == calcItem.guestIndex && calcId == calcItem.calcId) {
                    itemExists = true;
                    delete booking.calc[index];

                    let sopstveniItem = calcItem;
                    sopstveniItem.price = transferItem.price * -1;
                    sopstveniItem.priceIn = transferItem.priceIn * -1;
                    sopstveniItem.total = transferItem.price * -1;
                    sopstveniItem.totalIn = transferItem.priceIn * -1;
                    sopstveniItem.data.placeFromId.placeId = 0;
                    sopstveniItem.data.placeFromId.placeName = 'Sopstveni prevoz';
                    sopstveniItem.data.placeFromId.text = 'Sopstveni prevoz';
                    sopstveniItem.id = null;
                    sopstveniItem.isSopstveni = true;

                    booking.calc.push(sopstveniItem);
                }
            });

            transferItem && ! itemExists && booking.calc.push({
                guestIndex: guestIndex,
                calcId: transferItem.calcId,
                price: transferItem.price * -1,
                priceIn: transferItem.priceIn * -1,
                total: transferItem.price * -1,
                totalIn: transferItem.priceIn * -1,
                pricelistId: transferItem.pricelistId,
                //pricelistId: null,
                dateFrom: transferItem.dateFrom,
                dateTo: transferItem.dateTo,
                unitId: transferItem.unitId,
                quantity: 1,
                guests: '1,0,0',
                data : {
                    placeFromId: {
                        placeId: 0,
                        placeName: 'Sopstveni prevoz',
                        text: 'Sopstveni prevoz',
                    }
                },
                id: '1234',
                isSopstveni: true,
                inCalc: 1,
                isOptionl: 0,
                onSpot: 0,
                itemDefinitionId: {
                    id: 160,
                    text: 'Doplata za polazak',
                    typeId: {
                        id: 2,
                        key: "supplement",
                        text: "Doplata",
                    },
                    categoryId: {
                        id: 102,
                        key: "supplementForDeparture",
                        text: null
                    },
                    objectGroupId: {
                        id: 4,
                        key: "transfers",
                        text: "transfers",
                    },
                },
                paymentTypeId: {
                    id: 2,
                    key: "perPerson",
                    text: "po osobi",
                },
                rateTypeId: {         
                    id: 1,
                    key: "regular",
                    text: "Regularna cena",
                },
                skipCalculate: true,
            });

            booking.calc = booking.calc.filter(item => item);
        }

        //console.log(booking.calc);

        booking.calculate($target);
    },
    getGuestsData() {
        /*let guestsData = functions.getCookie('guestsData');
        guestsData = guestsData ? JSON.parse(guestsData) : {};

        for (const [index, guestData] of Object.entries(guestsData)) {
            const calcId = +index + 1;

            for (const [key, value] of Object.entries(guestData)) {
                $('[name="' + key + '"][data-calcId="' + calcId + '"]').val(value).trigger('change');
            }
        }*/
    },
    checkPaymentType() {
        // BOOKING PAYMENT TYPE CHECKBOX
        if($('[name="paymentType"]').length) {
            checkPaymentType();
            $('[name="paymentType"]').on('change', e => {
                checkPaymentType();
            });

            function checkPaymentType() {
                $('[name="paymentType"]').each((index, item) => {
                    const $item = $(item);
                    const id = $item.attr('id');
                    $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                });
            }
        }
    },
    prepareForBooking() {

        booking.calc = [];

        $("*[data-calc]").each(function (index) {
            let item = JSON.parse($(this).attr('data-calc'));
            item.inCalc = item.isOptional ? 0 : 1;
            booking.calc.push(item);
        });

        // calc items by unique itemId
        /*booking.calc = booking.calc.filter((value, index, self) => {
            return self.findIndex(v => v.id === value.id) === index;
        });*/

        if ( ! booking.calc.length) {
            return;
        }

        this.total();
    },
    itemTotal(item) {
        let itemTotal = 0.00;

        if (item.paymentTypeId.key) {

            if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                itemTotal = +item.quantity * +item.price;
            } else {
                itemTotal = +item.price;
            }
        } else {
            itemTotal = +item.quantity * +item.price;
        }

        return itemTotal;
    },
    total() {
        booking.totalAmount = 0.00;
        let cartItemsCalc = [];

        $.each(booking.calc, function (key, calc) {
            if (calc && ! calc.onSpot && calc.inCalc) {

                let totalAmount = booking.itemTotal(calc);

                if (! cartItemsCalc[calc.calcId]) {
                    cartItemsCalc[calc.calcId] = [];
                }

                cartItemsCalc[calc.calcId].push({totalAmount : totalAmount});

                booking.totalAmount += totalAmount;
            }
        });

        Object.keys(cartItemsCalc).forEach(key => {

            let items = cartItemsCalc[key];
            let $calc = $('.calc-' + key);
            let cartItemTotal = 0;

            $.each(items, function (key2, item) {
                cartItemTotal += item.totalAmount;
            });

            const $cartItemTotal = $calc.find('.cart-item-total');
            const currencySymbol = $cartItemTotal.attr('data-currencySymbol');
            $cartItemTotal.html(currencySymbol + ' ' + functions.formatMoney(cartItemTotal, 2, ',', '.'));
        });

        $('.cart-total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
        
        const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
        const advance = booking.totalAmount * (advancePaymentPercent / 100);
        const rest = booking.totalAmount - advance;

        $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
        $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));
    },
    calculate($elem) {
        let $calcItem = $elem.closest('.calc-item');
        
        let $checkbox = $calcItem.find('input[type="checkbox"]');
        let checked = $checkbox.is(':checked') ? 1 : 0;
        let id = $checkbox.attr('id');
        id = id ? id.split('-')[0] : id;
        let calcData = $calcItem.attr('data-calc') ? JSON.parse($calcItem.attr('data-calc')) : null;

        let $quantity = $calcItem.find('select.quantity:visible');
        let quantity = null;

        if ($quantity.length) {
            quantity = +$quantity.val();
        }

        $.each(booking.calc, function (key, calc) {
            //if (calc.id == id) {
            if (calcData && calc.id == id && calcData.calcId == calc.calcId) {

                if (quantity == null) {
                    quantity = booking.calc[key].quantity;
                }

                booking.calc[key].inCalc = checked;
                booking.calc[key].quantity = (quantity || 0);
                booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                let $itemTotalAmount = $calcItem.find('.item-total-amount');
                let currencySymbol = $itemTotalAmount.attr('data-currencysymbol');

                let itemTotalHTML = booking.calc[key].quantity > 0 
                    ? currencySymbol + ' ' + functions.formatMoney(booking.calc[key].total, 2, ',', '.') 
                    : $itemTotalAmount.attr('data-currencySymbol') + ' ' + $itemTotalAmount.attr('data-price');

                $itemTotalAmount.html(itemTotalHTML);

                const $itemPaymentType = $itemTotalAmount.siblings('.item-payment-type');
                let itemPaymentTypeHTML = booking.calc[key].quantity <= 1 ? $itemPaymentType.attr('data-paymentType') : '';
                $itemPaymentType.html(itemPaymentTypeHTML);
            }
        });

        booking.total();
    },
    applyDiscount(amount, percent, promoPerPerson, itemTitle, promoCodeId = null, quantity) {

        $(".table-calculation").each(function (index, elem) {
            let promoDiscountItem = JSON.parse($(elem).find(".calc-item.calc-item-mandatory:first").attr('data-calc'));
            let promoDiscountItemId = promoDiscountItem.id + '_' + 114;
            let total = 0;

            $.each(booking.calc, function (key, calc) {
                
                if (calc && promoDiscountItem.calcId === calc.calcId) {
                    
                    if (calc.inCalc && calc.itemDefinitionId.categoryId.key == 'baseRate') {
                        total += +calc.price;
                    }

                    if (calc.id == promoDiscountItemId) {
                        booking.calc.splice(key, 1);
                    }

                    if (calc.inCalc && ! calc.skipCalculate && calc.itemDefinitionId.typeId.key == 'discount') {
                        total += calc.price;
                    }
                }
            });

            let guests = promoDiscountItem.guests.split(',');
            guests = +guests[0] + +guests[1];
            
            if(quantity == 1) {
                guests = quantity;
                promoDiscountItem.guests = '1,0,0';
            }

            let discountAmountPrice = 0.00;
            if (+amount) {
                discountAmountPrice = (-1 * amount);
            } else {
                discountAmountPrice = (-1 * (total * (percent/100)));
            }

            promoDiscountItem.id = promoDiscountItemId;
            promoDiscountItem.itemDefinitionId.id = 105;

            promoDiscountItem.itemDefinitionId.text = itemTitle;
            promoDiscountItem.itemTitle = {
                name_sr: itemTitle
            };

            promoDiscountItem.quantity = 1;
            promoDiscountItem.itemDefinitionId.categoryId.id = 4;
            promoDiscountItem.itemDefinitionId.categoryId.key = 'discount';
            promoDiscountItem.itemDefinitionId.objectGroupId.id = 6;
            promoDiscountItem.itemDefinitionId.objectGroupId.key = 'excursions';
            promoDiscountItem.itemDefinitionId.typeId.id = 3;
            promoDiscountItem.itemDefinitionId.typeId.key = 'discount';
            promoDiscountItem.priceIn = 0;
            promoDiscountItem.price = discountAmountPrice;
            promoDiscountItem.totalIn = 0;
            promoDiscountItem.total = discountAmountPrice * promoDiscountItem.quantity;
            promoDiscountItem.skipCalculate = true;
            promoDiscountItem.inCalc = 1;
            promoDiscountItem.isOptional = 1;
            promoDiscountItem.perPerson = promoPerPerson ? 1 : 0;
            promoDiscountItem.promoCodeId = promoCodeId;

            if ($(elem).find(".calc-item.calc-item-mandatory:last").hasClass('calc-hidden')) {
                $('<div class="calc-item py-1 border-bottom promoDiscountItem" data-calc=\'' + JSON.stringify(promoDiscountItem) + '\'>\n' + '</div>').insertAfter($(elem).find(".calc-item.calc-item-mandatory:last"));
            } else {
                $('<div class="calc-item py-1 border-bottom promoDiscountItem" data-calc=\'' + JSON.stringify(promoDiscountItem) + '\'>\n' +
                    '    <div class="row ">\n' +
                    '        <div class="col-lg">\n' +
                    '            <div class="small fw-medium">' + itemTitle + '</div>\n' +
                    '            \n' +
                    '            <input name="quantity" type="hidden" value="">\n' +
                    '            \n' +
                    '            \n' +
                    '        </div>' +
                    '        <div class="col d-lg-none"></div>\n' +
                    '        \n' +
                    '        \n' +
                    '        <div class="col-4 col-lg-2 text-end text-uppercase">\n' +
                    '           <div class="calc-item-price">€ ' + functions.formatMoney( promoDiscountItem.total, 2, ',', '.') + '</div>\n' +
                    '        </div>\n' +
                    '     </div>\n' +
                    '\n' +
                    '</div>').insertAfter($(elem).find(".calc-item.calc-item-mandatory:last"));
            }

            booking.calc.push(promoDiscountItem);
            booking.calculate($(".promoDiscountItem"));
        });
    },
    submit() {
        let totalGuestData = [];

        $.each(booking.calc, function(key, item) {
            if ( ! item.inCalc) {
                delete booking.calc[key];
            } else if (item.itemDefinitionId.categoryId.key == 'baseRate' || item.itemDefinitionId.id == 160) {
                let $guestsPerProduct = $("[data-guests-parentId='" + item.calcId + "']");
                let guests = [];

                if ($guestsPerProduct.length) {
                    $guestsPerProduct.find('[data-guests]').each(function (index) {

                        let g = +$(this).data('guests');

                        if (item.guestIndex && +item.guestIndex != g) return;

                        let guestData = {
                            firstName : $(this).find("input[name='guestFirstName" + g + "']").val(),
                            lastName : $(this).find("input[name='guestLastName" + g + "']").val(),
                            birthDate : $(this).find("*[name='birthDateYear" + g + "']").length ? $(this).find("*[name='birthDateYear" + g + "']").val() + '-' + $(this).find("*[name='birthDateMonth" + g + "']").val() + '-' + $(this).find("*[name='birthDateDay" + g + "']").val() : null,
                            gender : $(this).find("*[name='gender" + g + "']").length ? $(this).find("*[name='gender" + g + "']").val() : null,
                        }

                        //guests[index] = guestData;
                        guests.push(guestData);

                        let guestExists = totalGuestData.find(guest => JSON.stringify(guest) === JSON.stringify(guestData));
                        ! guestExists && totalGuestData.push(guestData);
                    });
                    if (booking.calc[key]) booking.calc[key].guestsData = guests;
                }
                
            }

            // IS SUPPLEMENT FOR DEPARTURE
            if (item.itemDefinitionId.id == 160) {

                let transferItem = booking.calc.find(calcItem => {
                    return calcItem && calcItem.itemDefinitionId.id == 35;
                });

                if (transferItem && item.data) {
                    transferItem.data = item.data;

                    if (! item.data.placeFromId) {
                        item.data = JSON.parse(item.data);
                    }

                    transferItem.placeFromId = item.data.placeFromId.placeId;
                    transferItem.placeReturnId = item.data.placeReturnId?.placeId ?? transferItem.placeFromId;
    
                    let calcItemTitle = item.itemDefinitionId.text + ' - ' + item.data.placeFromId.placeName;
    
                    item.itemTitle = {
                        name_hr: calcItemTitle,
                        name_sr: calcItemTitle,
                    };

                    //item.data = JSON.stringify(item.data);
                    //booking.calc[key].data = JSON.stringify(item.data);
                }
            }
        });

        booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val() ? booking.$payment.find("[name='paymentType']:checked").val() : 'bankTransfer';
        
        let bookingMerged = [];

        function mergeGuests(firstGuests, secondGuests) {
            const first = (firstGuests || '0,0,0').split(',').map(Number);
            const second = (secondGuests || '0,0,0').split(',').map(Number);
          
            return first.map((value, index) => {
              return value + (second[index] || 0);
            }).join(',');
        }

        booking.calc.forEach((item, index) => {
            const cleanItem = item;

            if (cleanItem.isSopstveni) {

                let transferItem = booking.calc.find((item) => {
                    return item.itemDefinitionId?.id == 35 && cleanItem.calcId == item.calcId;
                });
                if (transferItem) {
                    transferItem.quantity -= 1;
                    transferItem.total -= transferItem.price;
                    transferItem.totalIn -= transferItem.priceIn;
        
                    let guests = transferItem.guests.split(',');
        
                    transferItem.guests = (+guests[0] - 1) + ',' + guests[1] + ',' + guests[2];

                    transferItem.guestsData = transferItem.guestsData.filter((guest, index) => {
                        return index != cleanItem.guestIndex; //! item.guestsData.includes(guest);
                    });
                    //transferItem.skipCalculate = true;

                    booking.calc[booking.calc.indexOf(transferItem)] = transferItem;
                }

                booking.calc[index].price = 0;
                booking.calc[index].priceIn = 0;
                booking.calc[index].total = 0;
                booking.calc[index].totalIn = 0;

            }
        });

        booking.calc.forEach((item, index) => {
            // guestIndex is excluded from cleanItem
            const { guestIndex, ...cleanItem } = item;
            //const cleanItem = item;

            if (cleanItem.itemDefinitionId?.id === 160) {
                const existingItem = bookingMerged.find(mergedItem =>
                    mergedItem.id === item.id && 
                    mergedItem.itemDefinitionId?.id === 160 &&
                    mergedItem.calcId === cleanItem.calcId
                );
            
                if (existingItem) {
                    existingItem.quantity += Number(cleanItem.quantity || 0);
                    //existingItem.price += Number(cleanItem.price || 0);
                    //existingItem.priceIn += Number(cleanItem.priceIn || 0);
                    existingItem.total += Number(cleanItem.total || 0);
                    existingItem.totalIn += Number(cleanItem.totalIn || 0);

                    existingItem.guests = mergeGuests(
                        existingItem.guests,
                        cleanItem.guests
                    );

                    existingItem.guestsData.push(...(cleanItem.guestsData || []));

                } else {
                    bookingMerged.push({
                        ...cleanItem,
                        quantity: Number(cleanItem.quantity || 0),
                        //price: Number(cleanItem.price || 0),
                        //priceIn: Number(cleanItem.priceIn || 0),
                        total: Number(cleanItem.total || 0),
                        totalIn: Number(cleanItem.totalIn || 0),
                        guests: cleanItem.guests || '0,0,0',
                        guestsData: [...(cleanItem.guestsData || [])]
                      });
                }
              } else {
                bookingMerged.push({ ...cleanItem });
              }
            
        });

        //let calculation = booking.calc.filter(item => item);
        let calculation = bookingMerged.filter(item => item);

        booking.params.calc = JSON.stringify(calculation);
        booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

        $.each(booking.params, function (key, param) {
            $('<input>').attr({
                type: 'hidden',
                name: key,
                value: param
            }).appendTo(booking.$form);
        });
    },
};